<template>
    <div id="loyalty-app" class="min-h-screen" style="background-color: #C8E1FB">
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'App'
};
</script>
